const addClass = {
  paid: "success",
  unpaid: "warning text-dark",
  expired: "danger",
  used: "success",

  active: "primary",
  inactive: "secondary",

  monthly: "primary",
  daily: "info",
  hotspot: "secondary",
  voucher: "info",

  new: "info",
  prepaid: "info",
  banned: "warning",
  deleted: "danger",
  complainManagement: "danger",
  smsBalance: "success",

  sent: "success",
  pending: "primary",
  rejected: "warning",
  accepted: "success",
  processing: "secondary",
  completed: "success",
  support: "primary",
  feature: "info",
  migration: "warning",
  auth: "info",

  registration: "danger",
  monthlyServiceCharge: "primary",
  smsPurchase: "info",
  sms: "info",

  other: "info",
  bill: "success",
  bulk: "primary",
  alert: "warning",
  resellerAlert: "warning",
  processed: "warning",
  failed: "danger",

  feature: "secondary",
  complain: "warning",

  drop: "primary",
  delete: "danger",
  trial: "dark",
  high: "danger",
  medium: "info",
  low: "secondary",

  Paid: "success",
  Unpaid: "warning",
  Expired: "danger",

  message: "info",
  SENT: "success",
  UNSENT: "primary",
  REJECTED: "danger",
  TRASH: "warning",

  superadmin: "primary",
  admin: "success",
  ispOwner: "primary",
  manager: "secondary",
  collector: "info",
  reseller: "primary",
  customer: "info",

  CREATE: "info",
  UPDATE: "success",
  DELETE: "danger",

  RECHARGE: "success",
  PAYMENT: "success",
  accept: "success",
  drop: "danger",

  online: "success",
  offline: "danger",

  dashboard: "info",
  report: "success",
  billing: "primary",

  resellerBilling: "info",
  invoice: "success",
  account: "success",
  up: "success",
  down: "danger",
};

export const badge = (item) => {
  return <span className={`badge bg-${addClass[item]}`}>{item}</span>;
};
